import { render, staticRenderFns } from "./TargetCompanyList.vue?vue&type=template&id=05fd3b20&"
import script from "./TargetCompanyList.vue?vue&type=script&lang=js&"
export * from "./TargetCompanyList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports